// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__kCL5g","wr":"styles_wr__TXCJS","tagName":"styles_tagName__ExYPo","tagsSection":"styles_tagsSection__2Bhvw","tag":"styles_tag__9nnrz"};